import cn from "classnames";
import st from "./service.module.scss";
import Heading from "@pages/partners/items/uralchem/components/heading/Heading";
import ServicePackCard from "./components/servicePackCard/ServicePackCard";
import React, { FC } from "react";
import { servicePacks } from "@pages/partners/items/uralchem/static/sectionsData";

interface ServiceProps {
    setTestType: (id: string) => void
    className: string
}

const Service: FC<ServiceProps> = ({setTestType, className}) => {
    return (
        <section className={cn(className, st['service'])}>
            <Heading.Section>Пакеты услуг</Heading.Section>
            <div className={st['service__list']}>
                {servicePacks.map(({heading, id, list, filled, listTitle, children}, index) => {
                    const withoutFlexFrom = Math.floor(servicePacks.length / 3) * 3 - 1;
                    return (
                        <ServicePackCard
                            heading={heading}
                            list={list}
                            filled={filled}
                            listTitle={listTitle}
                            onOrderBtnClick={() => {
                                setTestType(id);
                            }}
                            children={children}
                            style={{flex: index <= withoutFlexFrom ? '1 0 0' : 'unset'}}
                        />
                    )
                })}
            </div>
        </section>
    );
};

export default Service;